import React from 'react';
import SEAventures from '../logo/SEAventures.png';
// import QRCODE from '../qr/QRCODE.png';

const SalePrint = ({ onClose, labelData }) => {
    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px',
        marginLeft: '10px',
        marginRight: '0px',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100).trim();
            if (num < 100000) return (convert(Math.floor(num / 1000)) + ' Thousand ' + convert(num % 1000)).trim();
            if (num < 1000000) return (convert(Math.floor(num / 100000)) + ' Lakh ' + convert(num % 100000)).trim();
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        fontFamily: 'Arial, sans-serif',
        fontSize: '10px'
    };

    const cellStyle = {
        border: '1px solid #ccc',
        padding: '5px',
        textAlign: 'left',
    };

    const summaryRowStyle = {
        backgroundColor: '#e6f0ff', // Light blue for summary rows
        fontWeight: 'bold'
    };

    const totalRowStyle = {
        backgroundColor: '#d9d9d9', // Light gray for the total row
        fontWeight: 'bold',
        fontSize: '12px'
    };

    return (
        <div style={containerStyleN}>
            {labelData && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', flexDirection: 'column' }}>
                        {/* Logo Section */}
                        <div style={{ width: '50%', textAlign: 'center' }}>
                            <img
                                src={SEAventures}
                                alt="Company Logo"
                                style={{
                                    maxHeight: '100px',
                                    width: 'auto',
                                    height: 'auto',
                                    marginBottom: '5px',
                                }}
                            />
                        </div>

                        {/* Company Info Section */}
                        <div style={{ textAlign: 'center', marginTop: '5px', fontSize: '16px' }}>
                            <h5 style={{ margin: '0', fontWeight: 'normal' }}>
                                {labelData.SalePrint.CompanyAddressLine} {labelData.SalePrint.CompanyAddressLine2}
                            </h5>
                            <h5 style={{ margin: '0', fontWeight: 'normal', fontSize: '16px' }}>
                                {labelData.SalePrint.CompanyContactNumber1}
                            </h5>
                        </div>

                        <br />

                        {/* Date & Invoice Number Section */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: '12px', marginBottom: '5px', marginTop: '5px' }}>
                            {/* Left Empty for spacing */}
                            <div style={{ flex: 1 }}></div>

                            {/* Right-Aligned Date & Invoice No */}
                            <div style={{ textAlign: 'right', paddingRight: '30px', fontSize: '16px' }}>
                                <div style={{ marginBottom: '5px' }}>
                                    Datum: <span style={{ marginLeft: '3px', fontSize: '14px' }}>:</span> {new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}
                                </div>
                                <div>
                                    Referenznummer: <span style={{ marginLeft: '5px', fontSize: '16px' }}>:</span> {labelData.SalePrint.InvoiceNo}
                                </div>
                                <div style={{ marginTop: '5px', fontSize: '14px' }}>
                                    Rechnungsdatum entspricht Liefer-/Leistungsdatum
                                </div>
                            </div>
                        </div>

                        {/* Customer Info Section */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: '16px', marginBottom: '5px' }}>
                            <div style={{ flex: 1 }}>
                                <h5 style={{ margin: '0', fontWeight: 'normal', fontSize: '16px' }}>
                                    {labelData.SalePrint.CustomerName}
                                </h5>
                                <h5 style={{ margin: '0', fontWeight: 'normal', fontSize: '16px' }}>
                                    {labelData.SalePrint.CustomerAddress}
                                </h5>
                                <h5 style={{ margin: '0', fontWeight: 'normal', fontSize: '16px' }}>
                                    {labelData.SalePrint.CustomerContactNumber}
                                </h5>
                            </div>
                        </div>

                        <div style={{ fontSize: '17px', fontWeight: 'normal' }}>
                            <h3 style={{ fontSize: '25px', fontWeight: '400', margin: '0', marginTop: '-2%' }}> Rechnung</h3>
                            {/* Proforma */}
                        </div>

                        <br></br>

                        <div style={{ fontSize: '16px', fontWeight: 'normal', margin: '0', textAlign: 'left', lineHeight: '1.2', width: '100%' }}>
                            <p style={{ fontSize: '16px', margin: '0', padding: '0' }}>Sehr geehrter Herr {labelData.SalePrint.CustomerName},</p>
                            <p style={{ fontSize: '16px', margin: '0', padding: '0', marginTop: '5px' }}>vielen Dank für Ihren Auftrag. Vereinbarungsgemäß berechnen wir Ihnen hiermit folgende</p>
                            <p style={{ fontSize: '16px', margin: '0', padding: '0' }}>Leistungen:</p>
                        </div>

                        <br></br>


                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <td style={{ ...cellStyle, width: '5%', fontSize: '14px' }}>Position</td>
                                    <td style={{ ...cellStyle, width: '7%', fontSize: '14px' }}>Anzahl</td>
                                    <td style={{ ...cellStyle, width: '12%', fontSize: '14px' }}>Einheit</td>
                                    <td style={{ ...cellStyle, width: '30%', fontSize: '14px' }}>Bezeichnung</td>
                                    <td style={{ ...cellStyle, width: '10%', fontSize: '14px' }}>USt.</td>
                                    <td style={{ ...cellStyle, width: '12%', fontSize: '14px' }}>Einzelpreis (netto)</td>
                                    <td style={{ ...cellStyle, width: '17%', fontSize: '14px' }}>Gesamtpreis (netto)</td>
                                </tr>
                            </thead>
                            {/* <tbody> */}

                            <tbody>
                                {labelData && labelData.SalePrintItems.map((record, index) => {
                                    const isLastRecord = index === labelData.SalePrintItems.length - 1;
                                    const isFirstRecord = index === 0;
                                    return (
                                        <>
                                            {
                                                <tr key={index} style={{ height: '20px' }}>

                                                    <td style={{ ...cellStyle, height: '20px', width: '1%', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                        {record.ItemName && (
                                                            <div style={{ marginLeft: '5px' }}>
                                                                <label style={{ ...labelStyle, fontSize: '13px' }}>
                                                                    {index + 1}
                                                                </label>
                                                            </div>
                                                        )}
                                                    </td>

                                                    <td style={{ ...cellStyle, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                        <div style={{ marginLeft: '5px' }}>
                                                            <label style={{
                                                                marginTop: '5px',
                                                                fontFamily: 'Arial',
                                                                fontSize: '13px',
                                                                textAlign: 'right',
                                                                wordWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                                marginRight: '10px'
                                                            }}>
                                                                {record.Quantity !== 0 ? record.Quantity : ''}
                                                            </label>
                                                        </div>
                                                    </td>

                                                    <td style={{ ...cellStyle, height: '20px', width: '12%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                        <div style={{ marginLeft: '5px' }}>
                                                            <label style={{
                                                                marginTop: '5px',
                                                                fontFamily: 'Arial',
                                                                fontSize: '12px',
                                                                textAlign: 'left',
                                                                wordWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                                marginRight: '10px'
                                                            }}>

                                                                {record.UOM !== 0 ? record.UOM : ''}
                                                            </label>
                                                        </div>
                                                    </td>

                                                    <td style={{ ...cellStyle, height: '20px', width: '31.50%', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                        <div style={{ marginLeft: '5px' }}>
                                                            {record.ItemName && (
                                                                <div>
                                                                    {/* <label style={{ ...labelStyle, fontSize: '12px' }}> */}
                                                                    <label style={{
                                                                        marginTop: '5px',
                                                                        fontFamily: 'Arial',
                                                                        fontSize: '12px',
                                                                        textAlign: 'left',
                                                                        wordWrap: 'break-word',
                                                                        whiteSpace: 'normal',
                                                                        marginRight: '10px'
                                                                    }}>

                                                                        {record.ItemName}
                                                                    </label>
                                                                </div>
                                                            )}

                                                        </div>
                                                    </td>
                                                    <td style={{ ...cellStyle, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                        <div style={{ marginLeft: '5px' }}>
                                                            <label style={{
                                                                marginTop: '5px',
                                                                fontFamily: 'Arial',
                                                                fontSize: '12px',
                                                                textAlign: 'right',
                                                                wordWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                                marginRight: '10px'
                                                            }}>
                                                                {/* {record.TaxRate !== 0 ? record.TaxRate : ''} */}
                                                                {record.TaxRate !== 0 ? `${record.TaxRate} %` : ''}
                                                            </label>
                                                        </div>
                                                    </td>

                                                    <td style={{ ...cellStyle, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                        <div style={{ marginLeft: '5px' }}>
                                                            <label style={{
                                                                marginTop: '5px',
                                                                fontFamily: 'Arial',
                                                                fontSize: '13px',
                                                                textAlign: 'right',
                                                                wordWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                                marginRight: '10px'
                                                            }}>
                                                                {record.Rate && record.Rate !== 0 ? `${record.Rate.toFixed(2)} €` : ''}
                                                            </label>
                                                        </div>
                                                    </td>

                                                    <td style={{ ...cellStyle, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                        <label style={{ ...labelStyle, fontSize: '13px', marginRight: '10px' }}>
                                                            {record.TaxableAmount && record.TaxableAmount !== 0 ? `${record.TaxableAmount.toFixed(2)} €` : ''}
                                                        </label>
                                                    </td>

                                                </tr>
                                            }
                                        </>
                                    );
                                })}



                                {/* Summary Rows */}
                                <tr style={summaryRowStyle}>
                                    <td colSpan="6" style={{ ...cellStyle, fontWeight: 'normal', fontSize: '14px', color: '#09122C' }}>Nettopreis</td>
                                    <td style={{ ...cellStyle, textAlign: 'right', fontSize: '14px', color: '#09122C' , fontWeight:'normal'}}>{labelData.SalePrint.TaxableAmount.toFixed(2)} €</td>
                                </tr>
                             
                                {labelData.SalePrintTaxWise.map((tax, index) => (
                                    <tr key={index} style={summaryRowStyle}>
                                        <td colSpan="6" style={{ ...cellStyle, fontWeight: 'normal', fontSize: '14px', color: '#09122C' }}>
                                            Zzgl. {tax.TaxRate}% USt.
                                        </td>
                                        <td style={{ ...cellStyle, textAlign: 'right', fontSize: '14px' , color: '#09122C' , fontWeight:'normal'}}>
                                            {tax.TaxAmount && tax.TaxAmount !== 0 ? `${tax.TaxAmount.toFixed(2)} €` : ''}
                                        </td>
                                    </tr>
                                ))}

                                <tr style={totalRowStyle}>
                                    <td colSpan="6" style={{ ...cellStyle, fontWeight: 'normal', fontSize: '14px', color: '#09122C' }}>Round Off</td>
                                    <td style={{ ...cellStyle, textAlign: 'right', fontSize: '14px', color: '#09122C' , fontWeight:'normal'}}> {labelData.SalePrint.RoundOff && labelData.SalePrint.RoundOff !== 0 ? `${labelData.SalePrint.RoundOff.toFixed(2)} €` : ''}</td>
                                </tr>

                                {/* Total Row */}
                                <tr style={totalRowStyle}>
                                    <td colSpan="6" style={{ ...cellStyle, fontWeight: 'bold', fontSize: '14px', color: 'darkblue' }}>Rechnungsbetrag</td>
                                    <td style={{ ...cellStyle, textAlign: 'right', fontSize: '14px', color: 'darkblue' , fontWeight:'bold'}}> {labelData.SalePrint.TotalAmount && labelData.SalePrint.TotalAmount !== 0 ? `${labelData.SalePrint.TotalAmount.toFixed(2)} €` : ''}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div style={{ fontSize: '16px', fontWeight: 'normal', margin: '0', textAlign: 'left', lineHeight: '1.2', width: '100%' }}>
                            <p style={{ fontSize: '16px', margin: '0', padding: '0', marginTop: '5px' }}>Für weitere Fragen stehen wir Ihnen sehr gerne zur Verfügung.</p>
                            <p style={{ fontSize: '16px', margin: '0', padding: '0', marginTop: '3px' }}>Mit freundlichen Grüßen</p>
                        </div>

                        <div style={{ position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)', textAlign: 'center', fontSize: '16px' }}>
                            <h5 style={{ margin: '0', fontWeight: 'normal' }}>
                                {labelData.SalePrint.CompanyAddressLine} {labelData.SalePrint.CompanyAddressLine2}
                            </h5>
                            <h5 style={{ margin: '0', fontWeight: 'normal' }}>
                                {labelData.SalePrint.CompanyContactNumber1}
                            </h5>
                        </div>

                    </div>

                </>

            )
            }
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>
        </div >
    );
};

export default SalePrint;
